export default Object.freeze([
    {
        label: 'Pending - Business information not filled',
        description: 'The KYC form has not been submitted yet.',
        value: 'KYC_STATUS_ONE',
        color: '#b3b3b3',
        enumValue: 1,
        shouldBeAnOptionToSelect: false,
        order: 1
    },
    {
        label: 'Rejected',
        description: 'The KYC form needs to be resubmitted.',
        value: 'KYC_STATUS_REJECTED',
        color: '#e22400',
        enumValue: 2,
        shouldBeAnOptionToSelect: true,
        order: 4
    },
    {
        label: 'Pending',
        description: 'The KYC form is submitted.<<br>>The admin will only be able to call their own number.',
        value: 'KYC_STATUS_PENDING',
        color: '#d58400',
        enumValue: 3,
        shouldBeAnOptionToSelect: true,
        order: 2
    },
    {
        label: 'Approved',
        description: 'The KYC form is internally verified.<<br>>The admin will be able to test Calls and Messaging.<<br>>Outbound Messaging will be allowed once the compliance process is completed.',
        value: 'KYC_STATUS_APPROVED',
        color: '#2684ff',
        enumValue: 5,
        shouldBeAnOptionToSelect: true,
        order: 3
    },
    {
        label: 'Fraud Suspected',
        description: 'Trial is canceled, and login will not work.',
        value: 'KYC_STATUS_FRAUD_SUSPECTED',
        color: '#e22400',
        enumValue: 6,
        shouldBeAnOptionToSelect: true,
        order: 5
    }
])
